
import $ from 'jquery';
import eventBus         from 'EventBus';
import { View } from 'backbone';
import _Template from 'designer/breadcrumb.ejs';
import listService from 'ListService';
import mobileListService from '../service/mobile/MobileListService';
import constants from 'Constants';
import pageSyncService from 'PageSyncService';

class BreadCrumbView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.sectionId = null;

        this.events = {
            'click .breadCrumb-form-link' : 'formClicked',
            'click .breadCrumb-page-link' : 'pageClicked',
            'click .breadCrumb-section-link': 'sectionClicked',
            'click .breadCrumb-object-link': 'objectClicked'
        };

        this.listenTo( eventBus, 'updateBreadCrumb', this.updateBreadCrumb );

        return this;
    }

    updateBreadCrumb(type, id, ...otherParams) {
        $('.bcForm').removeClass('breadCrumb-form-link');
        $('.bcPage').removeClass('breadCrumb-page-link');
        $('.bcSection').removeClass('breadCrumb-section-link');
        $('.bcObject').removeClass('breadCrumb-object-link');
        $('.bcPage').addClass('hide');
        $('.bcSection').addClass('hide');
        $('.bcObject').addClass('hide');

        $('.bcForm').removeClass('active');
        $('.bcPage').removeClass('active');
        $('.bcObject').removeClass('active');

        if (type === 'FORM') {
            const fName = listService.currentForm.model.attributes.name;
            $('.bcForm').addClass('active');
        }

        if (type === 'PAGE' || type === 'OBJECT' || type === 'BEHAVIOR') {
            $('.bcPage').removeClass('hide');
            var pageId = listService.currentPageId;
            var page = listService.getPage(pageId);
            if (page) {
                const pName = page.model.attributes.name;
                $('.bcPage').text(' > ' + pName);
                $('.bcForm').addClass('breadCrumb-form-link');
            } else {
                const msg = `Breadcrumb processing: ID ${pageId} not a page`;
                console.log( msg );
                // notificationService.error( msg );
            }
        }

        if (listService.mainKind === constants.KIND_MOBILE && type === 'OBJECT') {
                const setBreadCrumbSection = (name, active = true) => {
                    const bcSection = $('.bcSection');
                    $('.bcPage').css({'cursor': 'default'});
                    bcSection.removeClass('hide')
                        .text(`> ${name}`)
                        .removeClass('active');
                    if (active) {
                        bcSection.addClass('active');
                    }
                };

                const setBreadCrumbControl = (name) => {
                    const bcObject = $('.bcObject');
                    bcObject.removeClass('hide')
                            .text(`> ${name}`)
                        .addClass('active');
                };

                const control = mobileListService.getMobileControl(id);
                if (control.model.get('factoryKey') === "control_section") {
                    this.sectionId = id;
                    setBreadCrumbSection(control.model.get('name'));
                }
                else {
                    setBreadCrumbControl(control.model.get('name'));
                    let controlId = id;
                    if (control._groupId) {
                        controlId = control._groupId;
                    }

                    const mobileObj = listService.getMobileObject(controlId);
                    const section = mobileListService.getMobileControl(mobileObj.sectionId)
                    this.sectionId = mobileObj.sectionId;
                    setBreadCrumbSection(section.model.get('name'), false);
                    $('.bcSection').addClass('breadCrumb-section-link');
                }
        }
        else {
            if (type === 'OBJECT') {
                $('.bcObject').removeClass('hide');
                const objId = id;
                const obj = listService.getObject(objId);

                if(obj){
                    const oName = obj.model.attributes.name;
                    $('.bcObject').text(' > ' + oName);
                    $('.bcPage').addClass('breadCrumb-page-link');
                    $('.bcObject').addClass('active');
                }
            }
            else if (type === 'BEHAVIOR') {

                $('.bcBehavior').removeClass('hide');

                const behavior = listService._behaviorInstanceList.get(id);
                if(behavior){                
                    const oName = behavior.get('name') || behavior.get('text');
                    $('.bcBehavior').text(' > ' + oName).addClass('active');
                    $('.bcPage').addClass('breadCrumb-page-link');

                    const owner = listService.getObject(behavior.get('ownerId'));
                    if (owner) {
                        $('.bcObject').removeClass('hide');
                        $('.bcObject').text(' > ' + owner.model.get('name'));
                        $('.bcObject').addClass('breadCrumb-object-link');
                    }
                }
            }
        }

        if (type === 'PAGE') {
            $('.bcPage').addClass('active');
        }
    }

    formClicked() {
        eventBus.trigger('selectForm');
    }

    pageClicked() {
        if (listService.mainKind === constants.KIND_BEHAVIORS) {
            pageSyncService.selectThumbNail(true);
        }
        else {
            eventBus.trigger('selectPage');
        }
    }

    sectionClicked() {
        if (listService.mainKind === constants.KIND_BEHAVIORS) {
            eventBus.trigger(constants.EV_SELECT_OBJECT, listService.currentId)
        }
        else {
            eventBus.trigger(constants.EV_SELECT_OBJECT, this.sectionId);
        }
    }

    objectClicked(ev) {
        ev.stopPropagation();

        if (listService.mainKind === constants.KIND_BEHAVIORS) {
            eventBus.trigger(constants.EV_SELECT_OBJECT, listService.currentId)
        }

    }

    render() {
        this.$el.html(this.template);

        let hideElement = (list) => { 
            list.forEach(e => {
                $(e).addClass('hide');
            }); 
        };

        let showElement = (list) => { 
            list.forEach(e => {
                $(e).removeClass('hide');
            }); 
        };

        const mode = this.options.mode;

        if (mode === 'R') { 
            hideElement(['.FormBreadcrumb', '.WorkflowBreadcrumb', '.BehaviorBreadcrumb']);
            showElement(['.ReportBreadcrum']);
        } else if (mode === 'L' || mode === constants.KIND_MOBILE) {
            hideElement(['.ReportBreadcrumb', '.WorkflowBreadcrumb', '.BehaviorBreadcrumb']);
            showElement(['.FormBreadcrumb']);
        } else if (mode === 'W') {
            hideElement(['.ReportBreadcrumb', '.FormBreadcrumb', '.BehaviorBreadcrumb']);
            showElement(['.WorkflowBreadcrumb']);
        } else if (mode === 'B') {
            hideElement(['.ReportBreadcrumb', '.FormBreadcrumb', '.WorkflowBreadcrumb']);
            showElement(['.BehaviorBreadcrumb']);
        }
        this.delegateEvents();
        return this;
    }

}

export default BreadCrumbView;
